import createWrapperMixin from "./createWrapperMixin";

const defaultState = {};

export default function createReducerMixin(WrappedComponent, reducer) {
    return class Reducer extends createWrapperMixin(WrappedComponent) {
        constructor(props, ...rest) {
            super(props, ...rest);
            this.state = reducer(defaultState, props, {});
        }

        componentWillReceiveProps(nextProps) {
            let state = reducer(this.state || defaultState, nextProps, this.props);
            if (state !== this.state) {
                this.setState(state);
            }
        }
    };
}


// WEBPACK FOOTER //
// ./src/kpi/common/createReducerMixin.js